import React, { FC } from 'react'
import { FluctuationType } from '../../../types/enterprise'
import { RankFluctuationIcon } from '../../../components/common/rank_fluctuation_icon'
import { RankFluctuationText } from '../../../components/common/rank_fluctuation_text'

type RankItemProps = {
  title: string
  rank: {
    rank: number
    total: number | null
    fluctuation: FluctuationType
  }
  label?: string
}

const RankItem: FC<RankItemProps> = (props) => {
  return (
    <div className="py-2 px-2 bg-main-gray rounded-xl flex justify-start min-h-[85px]">
      <div className="flex flex-col justify-center w-[42px]">
        <div className="flex justify-center">
          <RankFluctuationIcon type={props.rank.fluctuation} />
        </div>
        <div className="text-center">
          <RankFluctuationText type={props.rank.fluctuation} />
        </div>
      </div>
      <div className="pl-4">
        {props.label && <p className="text-xs opacity-75">{props.label}</p>}
        <p className="text-main-black font-bold">{props.title}</p>
        <div className="flex justify-start">
          <p className="text-main-black font-bold text-lg">
            {String(props.rank.rank)}位
          </p>
          {props.rank.total !== null && (
            <p className="text-xs text-main-darkgray leading-8">
              （全{String(props.rank.total)}位）
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

export default RankItem
